import { api } from "../../convex/_generated/api";
import { useContext } from "react";
import { BaseContext } from "../base-context";
import { useStableQuery } from "./useStableQuery";
import { Id } from "../../convex/_generated/dataModel";

export type RouteConditionKey = 'IsPersonalAssistantEnabled' | 'IsAdminEnabled'; // extend with more conditions as needed

export const useRouteCondition = (conditionKey: RouteConditionKey): boolean => {
    const { convexUserId } = useContext(BaseContext);
    const metadata = useStableQuery(api.user_metadata.getUserMetadata, convexUserId && conditionKey === 'IsPersonalAssistantEnabled' ? { user_id: convexUserId as Id<"users"> } : 'skip');

    switch (conditionKey) {
        case 'IsPersonalAssistantEnabled':
            // Return true if user metadata exists
            return !!metadata?.legal_name;
        default:
            return true; // Default to allowing access if condition key is not recognized
    }
};
